import React from "react"
import { useStrapiButtons } from "hooks/useStrapiButtons"
import { TextContentBlock } from "./TextContentBlock"
import {
  TextAndImageContentBlock,
  type TextAndImageContentBlockProps,
} from "./TextAndImageContentBlock"
import type { ReusableButtonGroup } from "_types/Button"
import type { RichTextContent } from "_types/RichText"

import "./content-block.module.scss"

interface ContentBlockParserProps
  extends Omit<TextAndImageContentBlockProps, "text"> {
  alternatingContentBlocks?: boolean
  index: number
  reusable_button_group: ReusableButtonGroup
  text: RichTextContent | null
}

export const ContentBlockParser = ({
  alternatingContentBlocks = false,
  heading,
  image,
  index,
  reusable_button_group,
  text,
  ...rest
}: ContentBlockParserProps) => {
  const { buttons } = rest
  const strapiButtons = useStrapiButtons(buttons, reusable_button_group)

  const getTextContentBlock = () => {
    const {
      alternate_background_color,
      eyebrow_text,
      style_lists_as_grid,
      sub_heading,
    } = rest

    if (!image || !image?.url) {
      return (
        <TextContentBlock
          sub_heading={sub_heading}
          eyebrow_text={eyebrow_text}
          heading={heading}
          text={text?.data?.text}
          alternate_background_color={alternate_background_color}
          buttons={strapiButtons}
          style_lists_as_grid={style_lists_as_grid}
        />
      )
    }
  }

  const getTextAndImageContentBlock = () => {
    if (text && image && image?.url) {
      const {
        alternate_background_color,
        alternateBlocksCount,
        content_block_type,
        eyebrow_text,
        sub_heading,
      } = rest

      return (
        <TextAndImageContentBlock
          index={index}
          heading={heading}
          text={text?.data?.text}
          sub_heading={sub_heading}
          eyebrow_text={eyebrow_text}
          image={image}
          content_block_type={content_block_type}
          alternate_background_color={alternate_background_color}
          isAltBlock={alternatingContentBlocks}
          alternateBlocksCount={alternateBlocksCount}
          style_list_as_grid={false}
          buttons={strapiButtons}
        />
      )
    }
  }

  return (
    <>
      {getTextContentBlock()}
      {getTextAndImageContentBlock()}
    </>
  )
}
